export type TFilter = {
  id: EFilter;
  title: string;
};

export type TListFilterState = {
  filterId: EFilter;
  asc: boolean;
};

export enum EFilter {
  OfficesCount = 'officesCount',
  Cost = 'cost',
  Payback = 'payback',
  Royalty = 'royalty',
  StartTime = 'startTime',
}
